import React, { useState } from "react";

import { urlService } from "services";
import { ActiveToolboxFacetType, IToolboxFacet } from "types";
import { useOnPersistedPageShow } from "utils";

import { ToolboxQuickSearchForm } from "../components";

interface ToolboxSearchAppProps {
  facets: IToolboxFacet[];
}

export const ToolboxQuickSearchContainer: React.FC<ToolboxSearchAppProps> = ({
  facets,
}) => {
  const [isLoading, setLoading] = useState(false);

  // bfcache fix
  useOnPersistedPageShow(() => setLoading(false));

  const handleSubmit = (data: ActiveToolboxFacetType) => {
    setLoading(true);

    // redirect to toolbox search single with chosen facets
    window.location.href = urlService.generateToolboxSearchUrl(data);
  };
  return (
    <div className="tool-quick-search">
      <ToolboxQuickSearchForm
        facets={facets}
        onSubmit={handleSubmit}
        isLoading={isLoading}
      />
    </div>
  );
};
